<div class="content wz-form-step">

  <div class="wz-head">
    <span class="wz-eyebrow">World Creation Wizard</span>
    <h2 class="wz-title">{{ mapName }} <span class="gold">global context</span></h2>
    <span class="wz-step">Part 1 of 3</span>
  </div>

  <div class="scroll-container flex-grow-1 px-3">
    <!-- Form Layout -->
    <div class="form-container mx-auto">

      <!-- Creation Story Row -->
      <div class="form-row mb-4">
        <label for="creationStory" class="form-label fw-bold">Creation story <span class="req">*</span></label>
        <div class="input-wrapper flex-grow-1">
          <textarea id="creationStory" class="form-textarea" rows="3" [(ngModel)]="creationStory"
            placeholder="Over countless ages, continents drifted, oceans carved coasts, and life evolved in cycles—until mortals rose and gave meaning to the wild."
          [class.is-invalid]="showErrorMsg && !creationStory.trim()"></textarea>
        </div>
      </div>

      <!-- Unique World Features Row -->
      <div class="form-row mb-4">
        <label for="uniqueFeatures" class="form-label fw-bold">Unique world features <span class="req">*</span></label>
        <div class="input-wrapper flex-grow-1">
          <textarea id="uniqueFeatures" class="form-textarea" rows="3" [(ngModel)]="uniqueFeatures"
            placeholder="Floating Shardlands, broken continents drift in the sky, linked by bridges, airships, and ancient arcane anchors"
          [class.is-invalid]="showErrorMsg && !uniqueFeatures.trim()"></textarea>
        </div>
      </div>

      <!-- Global Customs/Holidays Row -->
      <div class="form-row mb-4">
        <label for="customsHolidays" class="form-label fw-bold">Global customs / holidays <span class="req">*</span></label>
        <div class="input-wrapper flex-grow-1">
          <textarea id="customsHolidays" class="form-textarea" rows="3" [(ngModel)]="customsHolidays"
            placeholder="The Ember Vigil. A night of lanterns and silent prayers to honor the dead and ward off hungry spirits occurs twice annually"
          [class.is-invalid]="showErrorMsg && !customsHolidays.trim()"></textarea>
        </div>
      </div>

      <!-- Key Technological Innovations Row -->
      <div class="form-row mb-4">
        <label for="techInnovations" class="form-label fw-bold">Key technological innovations <span class="req">*</span></label>
        <div class="input-wrapper flex-grow-1">
          <textarea id="techInnovations" class="form-textarea" rows="3" [(ngModel)]="techInnovations"
            placeholder="Large airships that allow transport reshaping economies, armies, and travel across continents"
          [class.is-invalid]="showErrorMsg && !techInnovations.trim()"></textarea>
        </div>
      </div>

    </div>

    <!-- Validation Error Banner -->
    @if (showErrorMsg) {
      <div class="error-banner mb-3 mx-auto">
        <span class="error-text">{{ validationErrorText }}</span>
      </div>
    }

  </div>

  <div class="wz-actions">
    <button type="button" class="btn btn-dark" (click)="onBack()">Back</button>
    <button type="button" class="btn btn-theme" (click)="onNext()">Next</button>
  </div>

</div>
